export const navbar = [
    {
        id: 1,
        text: "Home",
        link: "/"
    },
    {
        id: 2,
        text: "Tracking",
        link: "/tracking"
    },
    {
        id: 3,
        text: "Reward",
        link: "/reward"
    },
    {
        id: 4,
        text: "Guides"
    }
]
